// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/nav-active-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/ava-cam.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/avatar.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/trendup.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/trenddown.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
body {
    background-color: #EFEFEF!important;
}
#page {
    overflow: hidden;
    margin-top: 103px;
}
.profile .navbar-small .collapse.show:before {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(100,100,100,0.5);
    content: '';
    z-index: 1;
}
{
    z-index: 11;
    position: relative;
}
.profile .navbar-small .user-badge-container, .profile .navbar-small .nav-container{
    z-index: 11;
    position: relative;
}
.profile .profile-nav {
    background: white;
}

.profile .profile-nav .nav-item, .profile .profile-nav .nav-link {
    font-style: normal;
    font-weight: 500;
    line-height: 132%;
    color: #2C262F !important;
}

.profile .profile-nav .nav-item .active {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: left;
    background-repeat: no-repeat;
}

.profile .settings .profile-content, .profile .subscription .profile-content, .profile .balance .profile-content  {
    background: white;
}

.profile .profile-section .header {
    font-style: normal;
    font-weight: 800;
    line-height: 117%;
    color: #2C262F;
}

.profile .profile-email-section {
    background: #EFEFEF;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 148%;
    color: #4A444C;
}

.profile .upgrade, .profile .subscribe {
    background: #4A444C;
    color: white;
}

.avatar-container {
    position: relative;
}
 .avatar-container .ava-cam {
    position: absolute;
     width: 48px;
     height: 48px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    z-index: 1;
}
 .avatar-container .ava-preview {
    position: absolute;
    left: 5%;
    right: 5%;
    top: 5%;
    bottom: 5%;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${___CSS_LOADER_URL_REPLACEMENT_2___}), #C7C6C8;
    border-radius: 140px;
    background-size: cover;
}
.profile .notifications .day-title, .profile .balance .day-title {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 148%;
    text-align: center;
    color: #2C262F;
}
.profile .notifications .msg {
    border-bottom: #2C262F;
}
.profile .subscription .label {
    font-weight: 400;
    font-size: 16px;
    line-height: 148%;
    color: #2C262F;
}
.profile-section.subscription img{
    height: auto;
}
.profile .balance .amount{
    font-style: normal;
    font-weight: 800;
    font-size: 48px;
    line-height: 117%;
    color: #FF855E;
}
.btn.rounded-pill img {
    margin-bottom: 4px;
    margin-left: 5px;
}
.btn.rounded-pill img.left {
    margin-bottom: 4px;
    margin-left: -3px;
    margin-right: 5px;
}
.profile .day-content .amount{
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 132%;
    text-align: right;
    color: #FF855E;
}
.card.recommendation-short .views.label {
    font-weight: 600;
    font-size: 16px;
    line-height: 148%;
    color: #2C262F;
}
.card.recommendation-short .views .trend-up{
    padding-left: 18px;
    background-repeat: no-repeat!important;
    background-position-y: center!important;
    color: #8BDE76;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.card.recommendation-short .views .trend-down{
    padding-left: 18px;
    background-repeat: no-repeat!important;
    background-position-y: center!important;
    color: #FF5368;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.card.recommendation-short .card-text{
    font-weight: 400;
    font-size: 16px;
    line-height: 148%;
    color: #2C262F;
    -webkit-line-clamp: 7;
    display: -webkit-box!important;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.card.recommendation-short .active.hidden{
    visibility: hidden;
}
.job-badge .date {
    /* caption */
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 148%;

    /* identical to box height, or 18px */
    letter-spacing: 0.02em;

    /* Dark */
    color: #2C262F;
}
.job-badge .job-avatar {
    width: 64px;
    height: 64px;
}
.job-badge .job-name {
    font-style: normal;
    font-weight: 700;
    line-height: 125%;
    color: #2C262F;
}
[data-bs-toggle="collapse"].collapsed .if-not-collapsed {
    display: none;
}
[data-bs-toggle="collapse"]:not(.collapsed) .if-collapsed {
    display: none;
}
.user-badge {
    max-width: 399px;
}
.user-badge .age {
    font-weight: 600;
    font-size: 12px;
    line-height: 148%;
    letter-spacing: 0.02em;
    color: #2C262F;
}
.user-badge .price {
    color: #FF855E;
}
.user-badge.big-title .age{
    font-weight: 400;
    font-size: 16px;
    line-height: 148%;
}
.user-badge .user-info {
    display: inline-block;
}
.user-badge .user-name {
    font-style: normal;
    font-weight: 500;
    line-height: 132%;
    color: #2C262F;
}
.user-badge .user-info .rating {
    display: inline-flex;
}

.user-badge .stars img {
    height: auto;
}
.recommender-batch .value .rating{
    display: inline-block;
}
.recommender-batch .status {
    font-weight: 600;
    font-size: 12px;
    line-height: 148%;
    letter-spacing: 0.02em;
    color: #6E6A70;
}
.user-badge .user-info .rating .value {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 148%;
    text-align: right;
    color: #2C262F;
}

.user-badge .avatar {
    width: 64px;
    height: 64px;
}

.profile-nav .balance {
    background: #EFEFEF;
    max-width: 272px;
}

.profile-nav.navbar-small .balance{
    max-width: 10000px;
}

.profile-nav .balance .amount {
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 125%;
    color: #FF855E;
}

.profile-nav .balance .label {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 132%;
    color: #2C262F;
}

.avatar {
    background: #C7C6C8;
    border-radius: 60px;
    width: 48px;
    height: 48px;
}
.avatar-big {
    max-width: 256px;
    max-height: 256px;
}
/* Rounded pill classes for horizontal sides */
.rounded-pill-left {
    border-top-left-radius: 50rem !important;
    border-bottom-left-radius: 50rem !important;
}
.rounded-pill-right {
    border-top-right-radius: 50rem !important;
    border-bottom-right-radius: 50rem !important;
}

/* Another classes to use */
.rounded-t-l-0 {
    border-top-left-radius: 0 !important;
}
.rounded-t-r-0 {
    border-top-right-radius: 0 !important;
}
.rounded-b-l-0 {
    border-bottom-left-radius: 0 !important;
}
.rounded-b-r-0 {
    border-bottom-right-radius: 0 !important;
}
.rounded-x-l-0 {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
}
.rounded-x-r-0 {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}
.input-group input  {
    border-left-width: 0;
}
.input-group input::placeholder {
    text-align: right;
}

/* Edge requires vendor prefix: */
.input-group input::-webkit-input-placeholder {
    text-align: right;
}
.input-group select {
    text-align: left;
    text-align-last:right;
    border-left-width: 0;
}

.create_job textarea, .create_recommendation textarea, .contact-talent textarea{
    height: 300px;
}
.create_recommendation {
    color: #4A444C !important;
}
.recommendation_published .img {
    width: 128px;
    height: 128px;
}

.recommendation .card-text{
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 132%;
    color: #2C262F;
}
.recommendation .rating-gauge .label,  .recommendation .rating-gauge{
    text-align: center;
}
.user-badge .recommender{
    color: #6E6A70;
    font-weight: 600;
    font-size: 12px;
    line-height: 148%;
    letter-spacing: 0.02em;
}
.find-talents fieldset legend {
    font-weight: 600;
    font-size: 12px;
    line-height: 148%;
    letter-spacing: 0.02em;
    color: #2C262F;
}
.find-talents fieldset .label {
    font-weight: 600;
    font-size: 16px;
    line-height: 148%;
    color: #2C262F;
}
.input-group input.rbt-input-main{
    border-radius: 0;
    color: #6c757d !important;
}
.input-group div.rbt {
    flex: auto;
}
.input-group div.rbt .dropdown-item{
    color: #6c757d !important;
}`, "",{"version":3,"sources":["webpack://./src/scss/components.css"],"names":[],"mappings":";AACA;IACI,mCAAmC;AACvC;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,iCAAiC;IACjC,WAAW;IACX,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,yDAAoD;IACpD,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;CACC;IACG,kBAAkB;KACjB,WAAW;KACX,YAAY;IACb,mDAAwC;IACxC,UAAU;AACd;CACC;IACG,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,OAAO;IACP,UAAU;IACV,2HAA+G;IAC/G,oBAAoB;IACpB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,uCAAuC;IACvC,cAAc;IACd,mDAAwC;AAC5C;AACA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,uCAAuC;IACvC,cAAc;IACd,mDAA0C;AAC9C;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,8BAA8B;IAC9B,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,qCAAqC;IACrC,sBAAsB;;IAEtB,SAAS;IACT,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA,8CAA8C;AAC9C;IACI,wCAAwC;IACxC,2CAA2C;AAC/C;AACA;IACI,yCAAyC;IACzC,4CAA4C;AAChD;;AAEA,2BAA2B;AAC3B;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,oCAAoC;IACpC,uCAAuC;AAC3C;AACA;IACI,qCAAqC;IACrC,wCAAwC;AAC5C;AACA;IACI,oBAAoB;AACxB;AACA;IACI,iBAAiB;AACrB;;AAEA,iCAAiC;AACjC;IACI,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,yBAAyB;AAC7B","sourcesContent":["\nbody {\n    background-color: #EFEFEF!important;\n}\n#page {\n    overflow: hidden;\n    margin-top: 103px;\n}\n.profile .navbar-small .collapse.show:before {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: rgba(100,100,100,0.5);\n    content: '';\n    z-index: 1;\n}\n{\n    z-index: 11;\n    position: relative;\n}\n.profile .navbar-small .user-badge-container, .profile .navbar-small .nav-container{\n    z-index: 11;\n    position: relative;\n}\n.profile .profile-nav {\n    background: white;\n}\n\n.profile .profile-nav .nav-item, .profile .profile-nav .nav-link {\n    font-style: normal;\n    font-weight: 500;\n    line-height: 132%;\n    color: #2C262F !important;\n}\n\n.profile .profile-nav .nav-item .active {\n    background-image: url('../images/nav-active-bg.png');\n    background-position: left;\n    background-repeat: no-repeat;\n}\n\n.profile .settings .profile-content, .profile .subscription .profile-content, .profile .balance .profile-content  {\n    background: white;\n}\n\n.profile .profile-section .header {\n    font-style: normal;\n    font-weight: 800;\n    line-height: 117%;\n    color: #2C262F;\n}\n\n.profile .profile-email-section {\n    background: #EFEFEF;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 148%;\n    color: #4A444C;\n}\n\n.profile .upgrade, .profile .subscribe {\n    background: #4A444C;\n    color: white;\n}\n\n.avatar-container {\n    position: relative;\n}\n .avatar-container .ava-cam {\n    position: absolute;\n     width: 48px;\n     height: 48px;\n    background: url(\"../images/ava-cam.png\");\n    z-index: 1;\n}\n .avatar-container .ava-preview {\n    position: absolute;\n    left: 5%;\n    right: 5%;\n    top: 5%;\n    bottom: 5%;\n    background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(\"../images/avatar.png\"), #C7C6C8;\n    border-radius: 140px;\n    background-size: cover;\n}\n.profile .notifications .day-title, .profile .balance .day-title {\n    font-style: normal;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 148%;\n    text-align: center;\n    color: #2C262F;\n}\n.profile .notifications .msg {\n    border-bottom: #2C262F;\n}\n.profile .subscription .label {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 148%;\n    color: #2C262F;\n}\n.profile-section.subscription img{\n    height: auto;\n}\n.profile .balance .amount{\n    font-style: normal;\n    font-weight: 800;\n    font-size: 48px;\n    line-height: 117%;\n    color: #FF855E;\n}\n.btn.rounded-pill img {\n    margin-bottom: 4px;\n    margin-left: 5px;\n}\n.btn.rounded-pill img.left {\n    margin-bottom: 4px;\n    margin-left: -3px;\n    margin-right: 5px;\n}\n.profile .day-content .amount{\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 132%;\n    text-align: right;\n    color: #FF855E;\n}\n.card.recommendation-short .views.label {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 148%;\n    color: #2C262F;\n}\n.card.recommendation-short .views .trend-up{\n    padding-left: 18px;\n    background-repeat: no-repeat!important;\n    background-position-y: center!important;\n    color: #8BDE76;\n    background: url(\"../images/trendup.png\");\n}\n.card.recommendation-short .views .trend-down{\n    padding-left: 18px;\n    background-repeat: no-repeat!important;\n    background-position-y: center!important;\n    color: #FF5368;\n    background: url(\"../images/trenddown.png\");\n}\n.card.recommendation-short .card-text{\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 148%;\n    color: #2C262F;\n    -webkit-line-clamp: 7;\n    display: -webkit-box!important;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n}\n.card.recommendation-short .active.hidden{\n    visibility: hidden;\n}\n.job-badge .date {\n    /* caption */\n    font-style: normal;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 148%;\n\n    /* identical to box height, or 18px */\n    letter-spacing: 0.02em;\n\n    /* Dark */\n    color: #2C262F;\n}\n.job-badge .job-avatar {\n    width: 64px;\n    height: 64px;\n}\n.job-badge .job-name {\n    font-style: normal;\n    font-weight: 700;\n    line-height: 125%;\n    color: #2C262F;\n}\n[data-bs-toggle=\"collapse\"].collapsed .if-not-collapsed {\n    display: none;\n}\n[data-bs-toggle=\"collapse\"]:not(.collapsed) .if-collapsed {\n    display: none;\n}\n.user-badge {\n    max-width: 399px;\n}\n.user-badge .age {\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 148%;\n    letter-spacing: 0.02em;\n    color: #2C262F;\n}\n.user-badge .price {\n    color: #FF855E;\n}\n.user-badge.big-title .age{\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 148%;\n}\n.user-badge .user-info {\n    display: inline-block;\n}\n.user-badge .user-name {\n    font-style: normal;\n    font-weight: 500;\n    line-height: 132%;\n    color: #2C262F;\n}\n.user-badge .user-info .rating {\n    display: inline-flex;\n}\n\n.user-badge .stars img {\n    height: auto;\n}\n.recommender-batch .value .rating{\n    display: inline-block;\n}\n.recommender-batch .status {\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 148%;\n    letter-spacing: 0.02em;\n    color: #6E6A70;\n}\n.user-badge .user-info .rating .value {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 148%;\n    text-align: right;\n    color: #2C262F;\n}\n\n.user-badge .avatar {\n    width: 64px;\n    height: 64px;\n}\n\n.profile-nav .balance {\n    background: #EFEFEF;\n    max-width: 272px;\n}\n\n.profile-nav.navbar-small .balance{\n    max-width: 10000px;\n}\n\n.profile-nav .balance .amount {\n    font-style: normal;\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 125%;\n    color: #FF855E;\n}\n\n.profile-nav .balance .label {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 132%;\n    color: #2C262F;\n}\n\n.avatar {\n    background: #C7C6C8;\n    border-radius: 60px;\n    width: 48px;\n    height: 48px;\n}\n.avatar-big {\n    max-width: 256px;\n    max-height: 256px;\n}\n/* Rounded pill classes for horizontal sides */\n.rounded-pill-left {\n    border-top-left-radius: 50rem !important;\n    border-bottom-left-radius: 50rem !important;\n}\n.rounded-pill-right {\n    border-top-right-radius: 50rem !important;\n    border-bottom-right-radius: 50rem !important;\n}\n\n/* Another classes to use */\n.rounded-t-l-0 {\n    border-top-left-radius: 0 !important;\n}\n.rounded-t-r-0 {\n    border-top-right-radius: 0 !important;\n}\n.rounded-b-l-0 {\n    border-bottom-left-radius: 0 !important;\n}\n.rounded-b-r-0 {\n    border-bottom-right-radius: 0 !important;\n}\n.rounded-x-l-0 {\n    border-top-left-radius: 0 !important;\n    border-bottom-left-radius: 0 !important;\n}\n.rounded-x-r-0 {\n    border-top-right-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n.input-group input  {\n    border-left-width: 0;\n}\n.input-group input::placeholder {\n    text-align: right;\n}\n\n/* Edge requires vendor prefix: */\n.input-group input::-webkit-input-placeholder {\n    text-align: right;\n}\n.input-group select {\n    text-align: left;\n    text-align-last:right;\n    border-left-width: 0;\n}\n\n.create_job textarea, .create_recommendation textarea, .contact-talent textarea{\n    height: 300px;\n}\n.create_recommendation {\n    color: #4A444C !important;\n}\n.recommendation_published .img {\n    width: 128px;\n    height: 128px;\n}\n\n.recommendation .card-text{\n    font-style: normal;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 132%;\n    color: #2C262F;\n}\n.recommendation .rating-gauge .label,  .recommendation .rating-gauge{\n    text-align: center;\n}\n.user-badge .recommender{\n    color: #6E6A70;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 148%;\n    letter-spacing: 0.02em;\n}\n.find-talents fieldset legend {\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 148%;\n    letter-spacing: 0.02em;\n    color: #2C262F;\n}\n.find-talents fieldset .label {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 148%;\n    color: #2C262F;\n}\n.input-group input.rbt-input-main{\n    border-radius: 0;\n    color: #6c757d !important;\n}\n.input-group div.rbt {\n    flex: auto;\n}\n.input-group div.rbt .dropdown-item{\n    color: #6c757d !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
